import { render, staticRenderFns } from "./TypeView.vue?vue&type=template&id=0ef32b0c&scoped=true&"
import script from "./TypeView.vue?vue&type=script&lang=js&"
export * from "./TypeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef32b0c",
  null
  
)

export default component.exports